import ApplyForAssessmentPage from "../components/competencyAssessment/applyForAssessment";

const ApplyForAssessment = () => {
  return <ApplyForAssessmentPage />;
};

export default ApplyForAssessment;
